function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M47.057 22.924H9.849a3.84 3.84 0 00-3.85 3.85v2.565c1.413 6.204 8.982 5.132 10.97 1.283 2.246 3.85 9.56 3.85 11.484 0 1.925 3.85 9.238 3.85 11.483 0 1.989 3.85 10.808 4.062 10.97-1.283v-2.566a3.84 3.84 0 00-3.85-3.849z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.566 33.124v16.744H48.34V33.055M31.019 15.226h-5.132v7.698h5.132zM20.113 16.509h-5.132v6.415h5.132zM41.642 16.509H36.51v6.415h5.132zM25.246 8.81c0 2.48 1.436 4.491 3.208 4.491s3.207-2.01 3.207-4.49c0-2.48-3.207-7.057-3.207-7.057S25.246 6.33 25.246 8.81zM28.453 10.094v5.132M15.103 11.377c0 1.89 1.094 3.421 2.444 3.421 1.35 0 2.444-1.531 2.444-3.421S17.547 6 17.547 6s-2.444 3.487-2.444 5.377zM17.547 12.354v3.91M36.633 11.377c0 1.89 1.094 3.421 2.444 3.421s2.444-1.531 2.444-3.421S39.077 6 39.077 6s-2.444 3.487-2.444 5.377zM39.076 12.354v3.91M50.906 49.868H6V55h44.906z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.393 42.059c-1.104-1.125-1.591-3.739-3.161-3.739-2.001 0-2.244 4.244-4.244 4.244-2 0-2.244-4.244-4.244-4.244-2 0-2.243 4.244-4.244 4.244-2 0-2.243-4.244-4.244-4.244s-2.243 4.244-4.244 4.244c-2 0-2.243-4.244-4.244-4.244-2 0-2.243 4.244-4.244 4.244s-2.243-4.244-4.244-4.244c-1.558 0-2.373 2.68-2.836 3.714"
}));

var SvgBirthdaycake = function SvgBirthdaycake(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBirthdaycake, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Birthday cake.c9d21158.svg";
export { ForwardRef as ReactComponent };